import * as types from '../constants/ActionTypes';

export function setCurrentImage(resourceInfo) {
  return {
    type: types.SET_CURRENT_IMAGE,
    resourceInfo
  };
}


export function resetCurrentImage() {
  return {
    type: types.RESET_CURRENT_IMAGE
  };
}



/** WEBPACK FOOTER **
 ** ./src/js/actions/UploadActions.js
 **/